import request from '@/utils/request'

export function loginByUsername(username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/api/auth/jwt/token',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/api/admin/user/front/info',
    method: 'get'
  })
}

export function getLanguage() {
  return request({
    url: '/api/dict/savorLanguage/getLanguages',
    method: 'get'
  })
}

export function loginBySsoToken(code) {
  return request({
    url: '/api/auth/jwt/token/' + code,
    method: 'post'
  })
}

export function loginByAppToken(token) {
  return request({
    url: '/api/auth/jwt/v1/token/app/' + token,
    method: 'post'
  })
}

export function logout(token) {
  return request({
    url: '/api/auth/jwt/invalid',
    method: 'post',
    params: {
      token
    }
  })
}
